﻿//custom visible binding to show/hide elements using jQuery's slideUp and slideDown
ko.bindingHandlers.slideVisible = {
    init: function (element, valueAccessor) {
        //initially set the element to be instantly visible/hidden depending on the value
        var value = valueAccessor();
        $(element).toggle(ko.unwrap(value));
    },
    update: function (element, valueAccessor) {
        //whenever the value subsequently changes, slideUp or slideDown the element
        var value = valueAccessor();
        ko.unwrap(value) ? $(element).slideDown() : $(element).slideUp();
    }
};